

export default {
  openId: localStorage.getItem('eleH5OpenId') || '', //
  photo: '',
  idCard: {},
  preposeDiploma: '', // 前置学历证书
  workCertificate: '', // 工作证明
  userId: localStorage.getItem('eleH5UserId') || '',
  userUniqueId: localStorage.getItem('eleH5UserUniqueId') || '',
  token: localStorage.getItem('eleH5Token') || '',
  studentNo: localStorage.getItem('eleH5StudentNo') || '',
  approvalStatus: localStorage.getItem('eleH5ApprovalStatus') || 0
};
